import { FC, ReactNode, useState } from 'react';
import CollapsableToggleItemHead, {
    CollapsableToggleItemHeadI,
} from '../collapsable-toggle-item-head/collapsable-toggle-item-head.component';
import CollapsableToggleItemPanel from '../collapsable-toggle-item-panel/collapsable-toggle-item-panel.component';

export interface CollapsableToggleItemI {
    id: string;
    children: ReactNode | string;
    item: Omit<CollapsableToggleItemHeadI, 'id'>;
}

const CollapsableToggleItem: FC<CollapsableToggleItemI> = ({ id, item, children }) => {
    const [open, setOpen] = useState(item?.defaultToggle ?? false);
    const handleToggle = (value: boolean) => {
        item?.onToggle && item.onToggle(value);
        setOpen(value);
    };
    return (
        <div className="border-t border-gray-50" key={id}>
            <CollapsableToggleItemHead id={id} {...item} onToggle={handleToggle} />
            {children && (
                <CollapsableToggleItemPanel open={open} testId={item.testId}>
                    {children}
                </CollapsableToggleItemPanel>
            )}
        </div>
    );
};

export default CollapsableToggleItem;
